import { Card, Grid, GridColumn, GridRow, LazyLoader, Table } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { Suspense, useEffect, useState } from 'react';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';
import { useUserConfigContext } from '../../hooks/useUserConfigContext';
import { useClassesTable } from '../Classes/hooks/useClassesTable';
import { ClassesTableType } from '../Classes/types/ClassesTypes';
import { ClassDivisionsTable } from './ClassDivisionsTable';

export const ClassDivisionsClassesTable = observer(() => {
  const permissions = usePermissionChecker();

  const { data, columns, tableSorting, tableSelection, tableSettings } = useClassesTable({
    context: 'divisions',
    columns: ['name', 'divisionsCount', 'color'],
  });

  const [classUuid, setClassUuid] = useState<string | null>(data[0].uuid ?? null);

  useEffect(() => {
    setClassUuid(data[0].uuid ?? null);
  }, [data[0].uuid]);

  return (
    <Grid>
      <GridRow>
        <GridColumn width={6}>
          <Table<ClassesTableType>
            data={data}
            columns={columns}
            {...tableSettings}
            {...tableSorting}
            {...tableSelection}
            onRowClick={(_event, row) => {
              setClassUuid(row.original.uuid);
            }}
            showRowHover
          />
        </GridColumn>
        <GridColumn width={6}>
          <Card contentPadding='none' style={{ paddingTop: 'var(--spacing-5)' }}>
            <Suspense fallback={<LazyLoader embedded />}>
              <ClassDivisionsTable classUuid={classUuid} readonly={!permissions?.canWriteTimetable()} />
            </Suspense>
          </Card>
        </GridColumn>
      </GridRow>
    </Grid>
  );
});
